import * as React from "react";
import { SVGProps } from "react";
export function JobTitleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.42 8.585a7.835 7.835 0 1 0-7.835 7.835"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.842 7.15a3.562 3.562 0 1 0-4.69 4.69m12.108 5.254-2.849-2.85 1.425-1.424a.711.711 0 0 0-.357-1.197l-6.596-1.631a.711.711 0 0 0-.861.862l1.63 6.596a.713.713 0 0 0 1.198.328l1.424-1.425 2.849 2.85 2.137-2.109Z"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
